import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-block content-block--separated contact-block"
}
const _hoisted_2 = {
  key: 0,
  class: "contact-block__sent"
}
const _hoisted_3 = { class: "contact-block__info text-center text-sm-left" }
const _hoisted_4 = { class: "content-line" }
const _hoisted_5 = { class: "content-line__text" }
const _hoisted_6 = { class: "content-line" }
const _hoisted_7 = { class: "content-line__text" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "content-line"
}
const _hoisted_11 = { class: "content-line__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_ctx.organization)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-center" }, " Have a question? Please ask us. ", -1)),
        _createVNode(_component_v_layout, {
          "justify-space-between": "",
          wrap: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              xs12: "",
              sm6: "",
              "order-1": "",
              "order-sm-0": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "contact-block__form" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                      ref: "form",
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.contactForm.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactForm.name) = $event)),
                          label: "Enter your name",
                          rules: [_ctx.rules.required],
                          variant: "outlined",
                          "append-icon": "person"
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.contactForm.email,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactForm.email) = $event)),
                          label: "Enter your email",
                          rules: [_ctx.rules.required, _ctx.rules.isEmail],
                          variant: "outlined",
                          "append-icon": "email"
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_phone_input, {
                          ref: "phoneInput",
                          outlined: "",
                          rules: [_ctx.rules.required]
                        }, null, 8, ["rules"]),
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.contactForm.message,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactForm.message) = $event)),
                          label: "Enter your message",
                          rules: [_ctx.rules.required],
                          variant: "outlined",
                          "append-icon": "message"
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          size: "large",
                          onClick: _ctx.sendForm
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.propertyId ? 'Contact Property' : 'Contact Company'), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 512),
                    (_ctx.formSent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          (_ctx.formError)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_v_icon, { color: "error" }, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode(" clear ")
                                  ])),
                                  _: 1
                                }),
                                _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "mb-5" }, " Message failed ", -1))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_v_icon, { color: "primary" }, {
                                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode(" check ")
                                  ])),
                                  _: 1
                                }),
                                _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "mb-5" }, " Message sent ", -1))
                              ], 64)),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            color: "primary",
                            onClick: _ctx.clearForm
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode(" Send again ")
                            ])),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.contactData)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  xs12: "",
                  sm5: "",
                  md4: "",
                  "order-0": "",
                  "order-sm-1": ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "content-line__title" }, " General ", -1)),
                        _createElementVNode("div", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.contactData.street) + ",", 1),
                          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.contactData.city) + ", " + _toDisplayString(_ctx.contactData.state) + " " + _toDisplayString(_ctx.contactData.code), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "content-line__title" }, " Management ", -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(_ctx.contactData.manager_fname) + " " + _toDisplayString(_ctx.contactData.manager_lname), 1),
                          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("a", {
                            href: 'tel:' + _ctx.contactData.phone_number
                          }, _toDisplayString(_ctx.contactData.phone_number), 9, _hoisted_8),
                          _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("a", {
                            class: "btnNoBorder",
                            href: `mailto:${ _ctx.contactData.manager_email }`,
                            target: "_top"
                          }, _toDisplayString(_ctx.contactData.manager_email), 9, _hoisted_9)
                        ])
                      ]),
                      (_ctx.contactData.office_hours)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "content-line__title" }, " Office Hours ", -1)),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.contactData.office_hours), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}